import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useTokenStore } from "@/src/store/use-token-store";
export const useSignIn = () => {
  const $tokenStore = storeToRefs(useTokenStore());
  const router = useRouter();

  const onSignIn = () => {
    window.location.href = "/api/v1/auth/cafe24";
  };

  const onResetSignOutSession = async () => {
    $tokenStore.accessToken.value = "";
    $tokenStore.refreshToken.value = "";
    await router.push("/");
  };

  const onSignOut = async () => {
    if (!confirm("로그아웃 하시겠습니까?")) {
      return;
    }
    await onResetSignOutSession();
  };

  return {
    onSignOut,
    onSignIn,
  };
};
